var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2552 26.0957C25.8963 26.0957 25.6092 26.3669 25.5693 26.7258C25.2583 29.8043 22.6583 32.2049 19.492 32.2049C16.3337 32.2049 13.7337 29.8043 13.4147 26.7258C13.3749 26.3748 13.0877 26.0957 12.7288 26.0957H4.43436C2.69571 26.0957 1.28406 27.5074 1.28406 29.246V35.8497C1.28406 37.5883 2.69571 39 4.43436 39H34.5657C36.3043 39 37.716 37.5883 37.716 35.8497V29.254C37.716 27.5153 36.3043 26.1037 34.5657 26.1037H26.2552V26.0957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2055 15.8393L21.7411 18.3037V2.2411C21.7411 1.00491 20.7362 0 19.5 0C18.2638 0 17.2589 1.00491 17.2589 2.2411V18.3037L14.7945 15.8393C14.0368 15.0816 12.8245 14.8902 11.9313 15.4883C10.711 16.3018 10.5914 17.9687 11.5724 18.9497L18.1761 25.5534C18.9098 26.2871 20.0982 26.2871 20.8319 25.5534L27.4356 18.9497C28.4166 17.9687 28.2969 16.3018 27.0767 15.4883C26.1755 14.8822 24.9632 15.0736 24.2055 15.8393Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2eecdd1bbc7f0049ea05b32f79b53b82.svg";
export { ForwardRef as ReactComponent };